import { useEffect } from 'react';
import { TeamHierarchyDto } from '@act/shared/data-transfer-objects';
import {
  getTeam,
  selectHierarchy,
  selectTeamLoadingStatus,
  selectViewable,
} from 'redux/slices/usersSlice';
import { useAppDispatch, useAppSelector } from 'redux/store-hooks';
import useIsAuthenticated from 'redux/utils/auth/is-authenticated-hook';
import { actingUserAppSelectors } from 'redux/slices/actingUserSlice';

const InitialDataHelper = () => {
  const hierarchy: TeamHierarchyDto[] = useAppSelector(selectHierarchy);
  const viewableGuides = useAppSelector(selectViewable);
  const teamLoadingStatus = useAppSelector(selectTeamLoadingStatus);
  const isAuthenticated = useIsAuthenticated();
  const actingUser = actingUserAppSelectors.useSelectActingUser();
  const dispatch = useAppDispatch();

  // Team Members ==============================================================
  useEffect(() => {
    if (!isAuthenticated) return;
    if (!actingUser?.hasAppAccess) return; // Don't load data if user doesn't have app access
    if (
      !hierarchy?.length &&
      viewableGuides === null &&
      teamLoadingStatus !== 'loading'
    ) {
      dispatch(getTeam({ params: { allViewable: true } }));
    }
  }, [
    dispatch,
    hierarchy,
    isAuthenticated,
    teamLoadingStatus,
    viewableGuides,
    actingUser?.hasAppAccess,
  ]);

  return <></>;
};

export default InitialDataHelper;
